import { Component, Input } from '@angular/core'

@Component({
  selector: 'mmx-eligibility-messages',
  templateUrl: './eligibility-messages.component.html',
  standalone: false,
})
export class EligibilityMessagesComponent {
  @Input() messages: { title?: string, message: string }[]
}
